import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { useNavigate } from "react-router-dom";

export const NavListItems = () => {
  const navigate = useNavigate();

  const handleNavlistItemClick = (item: string) => {
    navigate(`${process.env.PUBLIC_URL}/${item}`);
  };

  return (
    <React.Fragment>
      <ListItemButton
        id="home-page-button"
        onClick={() => handleNavlistItemClick("home")}
      >
        <ListItemIcon>
          <HomeOutlinedIcon color={"primary"} />
        </ListItemIcon>
        <ListItemText primary="Home" />
      </ListItemButton>
      <ListItemButton
        id="explore-page-button"
        onClick={() => handleNavlistItemClick("explore")}
      >
        <ListItemIcon>
          <ExploreOutlinedIcon color={"primary"} />
        </ListItemIcon>
        <ListItemText primary="Explore" />
      </ListItemButton>
      <ListItemButton
        id="explore-page-button"
        onClick={() => handleNavlistItemClick("rewrite")}
      >
        <ListItemIcon>
          <EditOutlinedIcon color={"primary"} />
        </ListItemIcon>
        <ListItemText primary="Rewrite" />
      </ListItemButton>
      <ListItemButton
        id="explore-page-button"
        onClick={() => handleNavlistItemClick("emails")}
      >
        <ListItemIcon>
          <EmailOutlinedIcon color={"primary"} />
        </ListItemIcon>
        <ListItemText primary="E-mail" />
      </ListItemButton>
    </React.Fragment>
  );
};

/* Control Flow: index -> App -> Wrapper -> Header -> SideNav -> NavListItems */
